export const GoogleMapApiConfig = 'AIzaSyCee_mo0EtlzSLDhI_EEVd_O1VgR90cIz0';